/**
 * Study Entity type names
 *
 * NOTE: do not change this freely, it must match the values in the database
 */
export var StudyEntityType;
(function (StudyEntityType) {
    StudyEntityType["StudyPopulation"] = "study.study_population";
    StudyEntityType["Epoch"] = "study.study_design.epoch";
    StudyEntityType["EpochConfiguration"] = "study.epoch_configuration";
    StudyEntityType["EpochGroup"] = "study.study_design.epoch_group";
    StudyEntityType["AllocationActivity"] = "study.study_design.epoch_group.allocation.allocation_activity";
    StudyEntityType["AllocationRule"] = "study.study_design.allocation_rule";
    StudyEntityType["AllocationRuleAttributes"] = "study.allocation_rule_attributes";
    StudyEntityType["Activity"] = "study.study_design.schedule_of_activities.activity";
    StudyEntityType["ActivityAttributes"] = "study.study_design.schedule_of_activities.activity.activity_attributes";
    StudyEntityType["ActivityScheduleRule"] = "study.study_design.schedule_of_activities.activity.schedule_rule";
    StudyEntityType["ActivityFootnote"] = "study.study_design.schedule_of_activities.activity_footnote";
    StudyEntityType["ActivityGroup"] = "study.study_design.schedule_of_activities.activity_group";
    StudyEntityType["Cycle"] = "study.cycle";
    StudyEntityType["StudyDynamicField"] = "study.dynamic_field";
    StudyEntityType["StudyDesign"] = "study.study_population.study_design";
    StudyEntityType["ScheduleOfActivities"] = "study.study_design.schedule_of_activities";
    StudyEntityType["ScheduleOfActivitiesOverlay"] = "study.schedule_of_activities_overlay";
    StudyEntityType["Intervention"] = "study.intervention";
    StudyEntityType["InterventionGroup"] = "study.intervention_group";
    StudyEntityType["InterventionGroupSequence"] = "study.intervention_group_sequence";
    StudyEntityType["ScheduledDay"] = "study.study_design.schedule_of_activities.scheduled_day";
    StudyEntityType["Study"] = "study";
    StudyEntityType["Section"] = "study.document.section";
    StudyEntityType["Stage"] = "study.stage";
    StudyEntityType["StageGroup"] = "study.stage_group";
    StudyEntityType["Variant"] = "study.variant";
    StudyEntityType["IntraDaySchedule"] = "study.intra_day_schedule";
    StudyEntityType["Objective"] = "study.objective";
    StudyEntityType["ObjectiveGroup"] = "study.objective_group";
    StudyEntityType["ObjectiveGroupSequence"] = "study.objective_group_sequence";
    StudyEntityType["Endpoint"] = "study.endpoint";
    StudyEntityType["Estimand"] = "study.estimand";
    StudyEntityType["StudyAssessmentMeasurement"] = "study.assessment_measurement";
    StudyEntityType["AssessmentMeasurementConfiguration"] = "study.assessment_measurement_configuration";
    StudyEntityType["AssessmentMeasurementConfigurationGroup"] = "study.assessment_measurement_configuration_group";
    StudyEntityType["Schema"] = "study.schema";
    StudyEntityType["ScheduleOfActivitiesGroup"] = "study.schedule_of_activities_group";
    StudyEntityType["ActivitySubGroup"] = "study.activity_sub_group";
    StudyEntityType["VeevaFormMapping"] = "study.veeva_form_mapping";
})(StudyEntityType || (StudyEntityType = {}));
//# sourceMappingURL=study-entity-type.js.map